import {Tidssoneinformasjon} from "../tjenester/i18n/GjeldendeTidssone";
import {ZonedDateTimePeriodeLukket} from "../typer/ZonedDateTimePeriode";
import {Lokaleinformasjon} from "../tjenester/i18n/GjeldendeLokale";
import {EnkelPlanModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

/** Returnerer angitt planperiode formatert som streng.
 * Følgende formater bruker avhengig av perioden: '2004' / '2004 (mar - okt)' / 'jan. 2013 - des. 2014' */
export function planperiodeSomTekst(periode: ZonedDateTimePeriodeLukket, tidssone: Tidssoneinformasjon, lokale: Lokaleinformasjon): string {
    const juster = periode.iTidssone(tidssone);
    //dersom start og slutt i forskjellige år viser vi 'yyyy mmm - yyyy mmm'
    if (juster.start.year != juster.slutt.year) {
        const start = juster.start.toLocaleString(lokale.somLocaleId(), {month: 'short', year: 'numeric'});
        const slutt = juster.slutt.toLocaleString(lokale.somLocaleId(), {month: 'short', year: 'numeric'})
        return `${start} - ${slutt}`;
    }

    const år = juster.start.toLocaleString(lokale.somLocaleId(), {year: 'numeric'});
    //dersom plan ikke spenner over hele året viser vi 'yyyy (mmm - mmm)
    if (juster.antallMåneder() < 12) {
        const mndStart = juster.start.toLocaleString(lokale.somLocaleId(), {month: 'short'});
        const mndSlutt = juster.slutt.toLocaleString(lokale.somLocaleId(), {month: 'short'})
        return `${år} (${mndStart} - ${mndSlutt})`;
    }

    return år;
}

export function lesPlanPeriode(plan: EnkelPlanModell): ZonedDateTimePeriodeLukket {
    return ZonedDateTimePeriodeLukket.les(plan.periode);
}
